import React from 'react';
import Dialog from 'material-ui/Dialog';
import {
  AddUserModal,
  CreateList,
  DeleteListModal
} from './Modals';

const modalType = Modal => {
  const ModalType = props => (
    <Dialog
      contentStyle={{
        width: props.modalWidth,
      }}
      bodyStyle={{
       maxHeight: 'unset'
      }}
      open={props.open}
      contentClassName="add-user-content"
      className="add-user-modal"
      paperClassName="add-user-paper"
    >
      {props.purpose === 'addUser' ? (
        <AddUserModal
          addUser={props.addUser}
          handleClose={props.handleClose}
          snackbarOpen={props.snackbarOpen}
          fvdomain_id={props.fvdomain_id}
          errors={props.errors}
          hasServerError={props.hasServerError}
          msg={props.msg}
        />
      ) : props.purpose === 'editUser' ? (
        <AddUserModal
          editUser={props.editUser}
          handleClose={props.handleClose}
          snackbarOpen={props.snackbarOpen}
          user={props.user}
          errors={props.errors}
          hasServerError={props.hasServerError}
          msg={props.msg}
          purpose={props.purpose}
        />
      ) : props.purpose === 'create-list' ? (
        <CreateList
          location={props.location}
          createContactList={props.createContactList}
          handleClose={props.handleClose}
        />
      ) : props.purpose === 'editName' ? (
        <CreateList
          location={props.location}
          updateContactList={props.updateContactList}
          contactId={props.contactId}
          name={props.name}
          handleClose={props.handleClose}
        />
      ) : props.purpose === 'deleteList' ? (
        <DeleteListModal
          location={props.location}
          deleteContactList={props.deleteContactList}
          contactId={props.contactId}
          handleClose={props.handleClose}
        />
      ) : (
        ''
      )}
    </Dialog>
  );
  return ModalType;
};

export default modalType;



// WEBPACK FOOTER //
// src/routes/Users/ListName/ModalHOC.js